import { render, staticRenderFns } from "./MarketplaceBadge.vue?vue&type=template&id=d5439f7c&scoped=true&"
import script from "./MarketplaceBadge.vue?vue&type=script&lang=js&"
export * from "./MarketplaceBadge.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceBadge.vue?vue&type=style&index=0&id=d5439f7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5439f7c",
  null
  
)

export default component.exports